"use client";

import React, { useRef } from "react";
import { Provider } from "react-redux";
import ErrorBoundary from "@/components/ErrorBoundary";
import Main from "@/redux/app/main";
import { Props } from "@/redux/interfaces/page";
import getStore, { AppStore } from "@/redux/store";

const App: React.FC<Props> = ({ children, pageProps, serverPathname }) => {
  const store = useRef<AppStore>();
  if (!store.current) store.current = getStore();

  return (
    <>
      <Provider store={store.current}>
        {/* <ErrorBoundary> */}
        <Main serverPathname={serverPathname} pageProps={pageProps}>
          {children}
        </Main>
        {/* </ErrorBoundary> */}
      </Provider>
    </>
  );
};

export default App;
